import * as yup from 'yup';
import * as personalSchema from './validations/personal';
import * as metaDataSchema from './validations/metaData';
import * as contactSchema from './validations/contact';
import * as financialSchema from './validations/financial';
import { createEmailsSchema, createPhonesSchema } from './primarySchema';

export const allowedPlasticColorsForSAS = ['PLATINUM', 'GOLD', 'GREEN'];

const createNamesSchema = () => yup.array().required('supplementaryApplicants.names.error').min(1)
  .of(yup.object()
    .shape({
      type: metaDataSchema.type,
      language: metaDataSchema.language,
      prefix: personalSchema.supplementary.prefix,
      title: personalSchema.supplementary.title,
      firstName: personalSchema.supplementary.firstName,
      middleName: personalSchema.supplementary.middleName,
      lastName: personalSchema.supplementary.lastName,
    })
  );

const primarySasSchema = {
  consents: yup.array().required('consents.error')
    .of(
      yup.object().shape({
        type: yup.string().oneOf(['ELECTRONIC_PAYMENT', 'TERMS'], 'consents.type.oneOf.error'),
        isAccepted: yup.boolean().required('consents.isAccepted.required.error'),
        dateTime: yup.string().notRequired(),
      })
    ),
  supplementaryApplicants: yup.array().notRequired()
    .of(
      yup.object().shape({
        plasticColor: yup.string().notRequired().oneOf(allowedPlasticColorsForSAS, 'supplementaryApplicants.plasticColor.oneOf.error'),
        names: createNamesSchema(),
        nameOnCard: personalSchema.nameOnCard,
        dateOfBirth: yup.string()
          .matches(/^\d{8}$/, 'dateOfBirth.error'),
        emails: createEmailsSchema({ errorMessagePrefix: 'supplementaryApplicants.' }),
        phones: createPhonesSchema({ errorMessagePrefix: 'supplementaryApplicants.' }),

        companies: yup.array().required('supplementaryApplicants.companies.error')
          .of(
            yup.object().shape({
              type: yup.string().oneOf(['PRIMARY'], 'supplementaryApplicants.companies.type.oneOf.error'),
              employments: yup.array().notRequired()
              .of(
                yup.object().shape({
                  status: yup.string().oneOf(financialSchema.employmentStatusValues, 'supplementaryApplicants.companies.employments.type.oneOf.error'),
                  occupation: yup.string().notRequired()
                })
              ),
              industries: yup.array().notRequired()
                .of(
                  yup.object().shape({
                    type: yup.string().oneOf(['PRIMARY'], 'supplementaryApplicants.companies.industries.type.oneOf.error'),
                    industry: financialSchema.industryConditionals.required,
                  })
                ),
            })
          ),

        hasSameAddressAsPrimary: yup.boolean().required('supplementaryApplicants.hasSameAddressAsPrimary.required.error'),

        addresses: yup.array()
          .when(['hasSameAddressAsPrimary'], {
            is: false,
            then: (schema) => schema.required('supplementaryApplicants.addresses.error').min(1)
              .of(
                yup.object()
                  .shape({
                    type: yup.string().oneOf(['HOME'], 'supplementaryApplicants.addresses.type.oneOf.error'),
                    language: metaDataSchema.language,
                    line1: contactSchema.addressline1,
                    line2: contactSchema.addressLine2,
                    postalCode: contactSchema.postalCode,
                    city: contactSchema.city,
                  })
              ),
            otherwise: (schema) => schema.notRequired(),
          }),

        inhabitanceInformation: yup.array().required('supplementaryApplicants.inhabitanceInformation.required.error')
          .of(
            yup.object()
              .shape({
                type: yup.string().oneOf(['BIRTH', 'NATIONALITY'], 'supplementaryApplicants.inhabitanceInformation.type.oneOf.error'),
                city: yup.string().test({
                  name: 'inhabitanceInformation.city.country',
                  test: function (value) {
                    const { country } = this.parent;
                    if(!!country === false && !!value) {
                      return true;
                    } else {
                      return !!country;
                    }
                  },
                  message: 'supplementaryApplicants.inhabitanceInformation.city.country.required.error'
                }),
                country: yup.string().test({
                  name: 'inhabitanceInformation.country.city',
                  test: function (value) {
                    const { city } = this.parent;
                    if(!!city === false && !!value) {
                      return true;
                    } else {
                      return !!city;
                    }
                  },
                  message: 'supplementaryApplicants.inhabitanceInformation.country.city.required.error'
                }),
              }),
            ),
      })
    ),
};


export default primarySasSchema;
